<template>
    <div class="datamain">
        <div class="contentbox">
            <div :class="allspflag ? ' lefthide' : 'leftbox'">
                <div :class="menu == item.name ? 'menuitem med' : 'menuitem'" v-for="(item, i) in menulist" :key="i"
                    @click="menuchange(item.name)">
                    <div class="icon"><img :src="menu == item.name ? item.iconed : item.icon" /></div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </div>
            <template v-if="menu != '视频'">
                <div class="rightbox">
                    <div class="databox">
                        <div class="el-icon-refresh refbox" @click="getshebeidatalist(1)"></div>
                        <div class="selectbox" v-if="menu == '大气'">
                            <el-select v-model="sbname" size="mini" @change="sbtypechange" placeholder="请选择"
                                v-if="sblist.length > 1">
                                <el-option v-for="item in sblist" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>

                        <el-carousel :interval="5000" style="height: 100%;" arrow="always" v-if="menu == '大气'">
                            <el-carousel-item v-for="item in valuelist" :key="item.id">

                                <div class="titname">{{ item.deviceName }}</div>
                                <div class="valuebox">
                                    <div class="valueitem" v-for="sitem in valuekeylist[sbname]" :key="sitem"
                                        :style="{ width: 'calc(100% / ' + (valuekeylist[sbname].length) + ' - 5px)', backgroundColor: item.deviceName + sitem.name == talkitem ? '#c0e2f4' : '' }"
                                        @click="gocreatque(sitem.name + '横向对比查看', item.deviceName + sitem.name)">
                                        <div class="name">{{ sitem.name }}</div>
                                        <div class="value">{{ item[sitem.value] }}</div>
                                        <div class="unit">{{ sitem.unit }}</div>
                                    </div>
                                </div>
                                <div class="uptime">更新时间：{{ item.time }}</div>
                            </el-carousel-item>
                        </el-carousel>
                        <el-carousel :interval="5000" style="height: 100%;" arrow="always" v-else>
                            <el-carousel-item v-for="item in valuelist" :key="item.id">
                                <div class="titname" style="margin-bottom: 0;color: #95671f;">{{ item.deviceName }}</div>
                                <div class="valuebox_t">
                                    <div class="valueitem" v-for="sitem in valuekeylist[sbname]" :key="sitem"
                                        @click="gocreatque(sitem.name + '横向对比查看', item.deviceName + sitem.name)">
                                        <div class="name">{{ sitem.name }}</div>
                                        <div class="value">{{ item[sitem.value] }}<span>{{ sitem.unit }}</span></div>
                                    </div>
                                </div>
                                <div class="uptime" style="padding-top: 2px;">更新时间：{{ item.time }}</div>
                            </el-carousel-item>
                        </el-carousel>

                    </div>

                </div>
                <!-- :style="{ height: allspflag ? 'calc(100% - 10px)' : 'calc(100% - 175px)' }" -->
                <div class="talkbox"
                    :style="{ width: allspflag ? 'calc(100% - 20px)' : 'calc(100% - 80px)', background: menu == '大气' ? 'linear-gradient(180deg, #B0D393 0%, #b2d49903 100%)' : 'linear-gradient(180deg, #e2c69b 0%, #b2d49903 100%)' }">
                    <div class="talktitle"><i @click="clickallap"
                            :class="allspflag ? 'allap el-icon-s-unfold' : 'allap el-icon-s-fold'"></i><span
                            @click="createtalk">实时精准感知关键环境数据</span>
                    </div>
                    <div class="content" id="resultbox">

                        <div class="zhuibox">
                            <div class="zhuiitem" v-for="(item, i) in quelist" :key="i" @click="sendmes(item)"
                                v-if="isfirst">
                                {{ item }}
                            </div>
                            <span v-for="(item, i) in talklist" :key="i">
                                <div class="useritem" v-if="item.message.length > 0">
                                    <div class="userleft"><img src="@/assets/img/home/user.png" /></div>
                                    <div class="userright">
                                        <div class="usertext">
                                            {{ item.message }}
                                            <div v-if="item.talkimgurl" class="userimg"><img style="max-width: 80%;"
                                                    :src="item.talkimgurl" /></div>
                                        </div>

                                    </div>
                                </div>
                                <div class="aiitem">
                                    <div class="aileft"><img src="@/assets/img/head.png" /></div>
                                    <div class="airight">
                                        <div class="airesultimg"
                                            v-if="item.reply_content && (item.reply_content.imagereplys || item.reply_content.imagereply)">
                                            <!-- <img v-for="imgitem in item.reply_content.resultimgs" :key="imgitem" :src="imgitem" /> -->
                                            <el-image
                                                v-for="imgitem in (item.reply_content.imagereplys || [item.reply_content.imagereply])"
                                                :key="imgitem"
                                                :src="imgitem.replace('http://47.96.179.72:11454/', 'http://strawberryai.web.shuzhiren.com/klgapi/')"
                                                :preview-src-list="srcList">
                                            </el-image>
                                        </div>
                                        <div class="aitext">

                                            <el-button type="text"
                                                v-if="item.reply_content.result == '' && !item.reply_content.thinktxt"
                                                icon="el-icon-loading">生成中..</el-button>
                                            <span v-else>
                                                <!-- <div>总结：</div> -->
                                                <div class="resultbox"
                                                    v-if="item.reply_content.thinktxt && item.reply_content.thinktxt.length > 0">
                                                    <el-collapse v-model="activeNames">
                                                        <el-collapse-item name="1">
                                                            <template slot="title">
                                                                <i class="el-icon-s-opportunity"></i>思考过程
                                                            </template>
                                                            <vue-markdown :source="item.reply_content.thinktxt"
                                                                class="custom-markdown"></vue-markdown>
                                                        </el-collapse-item>
                                                    </el-collapse>

                                                    <!-- {{ item.reply_content.thinktxt }} -->
                                                </div>

                                                <vue-markdown :source="item.reply_content.result"
                                                    class="custom-markdown"></vue-markdown>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                    </div>

                </div>
                <div :class="allspflag ? 'sendboxhide' : 'sendbox'">
                    <!-- <div class="photo" @click="triggerUpload">
                        <img src="@/assets/img/home/photo.png" />
                        <input id="fileInput" type="file" style="display: none" ref="fileInput"
                            @change="handleFileChange" />
                    </div> -->
                    <div @click="opensd" :class="issd ? 'skbtn skbtned' : 'skbtn'">DS-R1</div>
                    <div class="inputbox">
                        <div class="talkimg" v-if="talkimgurl" @click="talkimgurl = ''">
                            <div class="delbox">×</div><img :src="talkimgurl" />
                        </div>
                        <input type="text" id="qmess" class="sendinput" placeholder="点我智问" />
                        <div @click="stopconn" v-if="isconn" class="delbtn"><i class="el-icon-video-pause"></i></div>
                    </div>
                    
                    <!-- <div style="margin-left: 10px;" class="skbtn skbtned">联网</div> -->
                    <div class="btnbox" style="margin-left: 10px;" @click="senmessage"><img src="@/assets/img/home/send.png" alt=""></div>
                </div>
            </template>
            <div class="videobox" v-else>
                <span  v-for="(item, i) in Object.keys(cameralist)" :key="i">
                    <p>{{item}}</p>
                    <iframe  style="width:100%;height:188px;border:0"
                        class="myiframe" :src="cameralist[item]" />
                </span>
                
            </div>
        </div>
    </div>

</template>

<script>
import router from '../router'
import axios from "axios";
import Vue from 'vue';
import { getbcmsblist, getsbdatalist, getweatherdata } from '@/api/bot'
import qs from 'qs'
import VueMarkdown from 'vue-markdown'
import { baseUrl } from '@/axios/baseUrl'
import m1 from '@/assets/img/home/m1.png'
import m1ed from '@/assets/img/home/m1ed.png'
import m2 from '@/assets/img/home/m2.png'
import m2ed from '@/assets/img/home/m2ed.png'
import m3 from '@/assets/img/home/m3.png'
import m3ed from '@/assets/img/home/m3ed.png'
import m4 from '@/assets/img/home/m4.png'
import m4ed from '@/assets/img/home/m4ed.png'
import { off } from 'process';
export default {
    name: 'index',
    components: { VueMarkdown },
    data() {
        return {
            menu: '大气',
            issd: false,
            sblist: [],
            valuelist: [],
            eventSource: null,
            talklist: [],
            isfirst: true,
            srcList: [],
            sbname: '',
            isconn: false,
            weatherdata: [],
            activeNames: ['1'],
            menulist: [{
                icon: m1,
                iconed: m1ed,
                name: '大气'
            }, {
                icon: m2,
                iconed: m2ed,
                name: '土壤'
            }, {
                icon: m3,
                iconed: m3ed,
                name: '视频'
            }, {
                icon: m4,
                iconed: m4ed,
                name: '设备'
            }],
            valuekeylist: {
                "大气环境监测传感器": [{
                    name: '温度',
                    value: 'temp',
                    unit: '℃',
                }, {
                    name: '湿度',
                    value: 'humi',
                    unit: '%',
                }, {
                    name: '二氧化碳',
                    value: 'co2',
                    unit: 'ppm',
                }, {
                    name: '光照',
                    value: 'light',
                    unit: 'Lux',
                }],
                "土壤": [{
                    name: '含氮量',
                    value: 'nitrogen',
                    unit: 'mg/kg',
                }, {
                    name: '含磷量',
                    value: 'phosphorus',
                    unit: 'mg/kg',
                }, {
                    name: '含钾量',
                    value: 'potassium',
                    unit: 'mg/kg',
                }, {
                    name: '含水率',
                    value: 'water',
                    unit: '%RH',
                }, {
                    name: '温度',
                    value: 'temp',
                    unit: '℃',
                }, {
                    name: '电导率',
                    value: 'conductivity',
                    unit: 'us/cm',
                }, {
                    name: 'PH值',
                    value: 'ph',
                    unit: '',
                }],
                // "土壤温湿度EC传感器": [{
                //     name: '含水率',
                //     value: 'water',
                //     unit: '%RH',
                // }, {
                //     name: '温度',
                //     value: 'temp',
                //     unit: '℃',
                // }, {
                //     name: '电导率',
                //     value: 'conductivity',
                //     unit: 'us/cm',
                // }],
                // "土壤PH传感器": [{
                //     name: 'PH值',
                //     value: 'ph',
                //     unit: '-',
                // }]
            },
            quelist: [
                '昨天大棚内平均气温是多少？',
                '未来3天赣州市天气情况怎么样？',
                '现在大棚内土壤湿度是多少，需要浇水吗？',
                '昨天赣州市的降雨量是多少？'
            ],
            talkguanlianid: '',
            allspflag: false,
            talkitem: '',
            talkimgurl: '',
            cameralist: {
                '赣南龙莓火燃村B区1-1': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001320000001_34020000001320000001.live.flv',
                '赣南龙莓火燃村B区1-2': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001320000001_34020000001320000002.live.flv',
                '赣南龙莓火燃村B区2-1': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001330000001_34020000001330000001.live.flv',
                '赣南龙莓火燃村B区2-2': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001330000001_34020000001330000002.live.flv',
                '赣南龙莓火燃村C区C-1': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001340000001_34020000001320000001.live.flv',
                '赣南龙莓火燃村C区C-2': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001350000001_34020000001320000001.live.flv',
                '赣南龙莓火燃村C区C-3': 'https://video.guanyingis.com/#/play/wasm/wss%3A%2F%2Fvideo.guanyingis.com%3A443%2Frtp%2F34020000001360000001_34020000001320000001.live.flv',
            },
        }
    },
    computed: {

    },
    mounted() {
        this.getshebeilist()
        this.gettoken()
    },
    methods: {
        gettoken() {
            let xhr = new XMLHttpRequest();
            xhr.open('POST', 'http://strawberryai-pc.web.shuzhiren.com/ysapi/lapp/token/get?appKey=bc1643c4b63d4fec98b730bc0df893dd&appSecret=4ebaee0ba17166eb1a92ab9b5325fdb8');
            const param = {
                appKey: 'bc1643c4b63d4fec98b730bc0df893dd',
                appSecret: '4ebaee0ba17166eb1a92ab9b5325fdb8'
            }
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            
            xhr.send(JSON.stringify(param));
            // param.append('appKey', 'bc1643c4b63d4fec98b730bc0df893dd')
            // param.append('appSecret', '4ebaee0ba17166eb1a92ab9b5325fdb8')
            const that = this;
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const res = JSON.parse(xhr.responseText);
                    console.log('萤石', res)
                    this.asstoken = res.data.accessToken
                    setTimeout(() => {
                        this.formatlist()
                    }, 300);
                }
            }

        },
        formatlist() {
            // 获取所有摄像头名称的数组
            const cameraNames = Object.keys(this.cameralist);

            // 筛选出后三个摄像头（从索引4开始，共3个）
            const targetCameras = cameraNames.slice(-3);

            // 新的accessToken值
            const newAccessToken = this.asstoken;

            // 遍历后三个摄像头并修改accessToken
            targetCameras.forEach(cameraName => {
                const oldUrl = this.cameralist[cameraName];
                // 使用正则替换accessToken参数的值
                const newUrl = oldUrl.replace(/accessToken=([^&]+)/, `accessToken=${newAccessToken}`);
                this.cameralist[cameraName] = newUrl;
            });

            console.log('修改后的摄像头列表：', this.cameralist);
        },
        createtalk() {
            const that = this;
            that.talklist = []
            that.talkguanlianid = ''
            that.isfirst = true
            // })
        },
        gocreatque(text, type) {
            console.log(text, type)
            this.sendmes(text)

            this.talkitem = this.talkitem == type ? '' : type
        },
        clickallap() {
            this.allspflag = !this.allspflag;
        },
        menuchange(e) {
            if (e == '设备') {
                this.$message.error('功能正在开发')
                return;
            }
            this.menu = e
            this.isfirst = true
            this.talklist = []
            setTimeout(() => {
                this.getshebeilist()
            }, 200);
        },
        sbtypechange() {
            this.getshebeidatalist()
        },
        handleFileChange(event) {
            const file = event.target.files[0]; // 获取选中的文件
            // 处理文件上传的逻辑...
            this.$message.info('图片正在上传..')
            const xhr = new XMLHttpRequest();
            const formdata = new FormData();
            formdata.append('file', file)
            xhr.open('POST', baseUrl + '/queapi/file/oss', true);
            xhr.send(formdata);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const res = JSON.parse(xhr.responseText);
                    this.talkimgurl = res.message
                    this.$message.success('上传成功')
                    console.log(res.message)
                }
            }
        },
        getshebeidatalist(e) {


            const param = this.menu == '大气' ? `device_type=${this.sbname}&type=${this.menu}` : `type=${this.menu}`
            getsbdatalist(param).then(res => {
                if (e) {
                    this.$message.success('数据已更新')
                }
                console.log(res)
                // if (this.valuelist.length > 0) {
                //     this.$message.success('数据已刷新')
                // }
                const newdata = []
                if (this.menu == '大气') {
                    this.valuelist = res.data
                } else {
                    const sblist = []
                    res.data.forEach(item => {
                        if (!sblist.includes(item.deviceName.substr(0, item.deviceName.indexOf('排')))) {
                            sblist.push(item.deviceName.substr(0, item.deviceName.indexOf('排')))
                        }
                    })

                    res.data.forEach(sitem => {
                        sblist.forEach(item => {
                            if (sitem.deviceName.substr(0, sitem.deviceName.indexOf('排')) == item) {
                                const itemed = newdata.filter(s => s.deviceName == item + "排土壤传感器")
                                if (itemed[0]) {
                                    if (sitem.conductivity) {
                                        itemed[0].conductivity = sitem.conductivity
                                    } if (sitem.nitrogen) {
                                        itemed[0].nitrogen = sitem.nitrogen
                                    } if (sitem.phosphorus) {
                                        itemed[0].phosphorus = sitem.phosphorus
                                    } if (sitem.potassium) {
                                        itemed[0].potassium = sitem.potassium
                                    } if (sitem.ph) {
                                        itemed[0].ph = sitem.ph
                                    } if (sitem.temp) {
                                        itemed[0].temp = sitem.temp
                                    } if (sitem.water) {
                                        itemed[0].water = sitem.water
                                    }
                                } else {
                                    newdata.push({
                                        conductivity: sitem.conductivity,
                                        createTime: sitem.createTime,
                                        deviceName: item + "排土壤传感器",
                                        id: 7,
                                        nitrogen: sitem.nitrogen,
                                        ph: sitem.ph,
                                        phosphorus: sitem.phosphorus,
                                        potassium: sitem.potassium,
                                        sensorId: 4,
                                        temp: sitem.temp,
                                        time: sitem.time,
                                        updateTime: sitem.time,
                                        water: sitem.water
                                    })
                                }


                            }
                        })

                    })
                    this.valuelist = newdata
                }

            })
        },
        getshebeilist() {
            getbcmsblist(this.menu).then(res => {
                console.log(res)
                this.sblist = res.data
                this.sbname = this.menu == '大气' ? res.data[0] : '土壤'
                setTimeout(() => {
                    this.getshebeidatalist()
                }, 200);
            })
        },
        opensd() {
            this.issd = !this.issd
        },
        sendmes(msg) {
            this.isfirst = false
            document.getElementById('qmess').value = msg
            setTimeout(() => {
                this.senmessage()
            }, 200);
        },
        triggerUpload() {
            this.$refs.fileInput.click(); // 触发input的点击事件
        },
        senmessage() {
            let message = document.getElementById('qmess').value
            if (message == '' && this.talkimgurl) {
                message = '帮我分析一下这张图片'
            }
            if (message == '' || this.isconn) return;
            this.talklist.push({
                message: message,
                talkimgurl: this.talkimgurl,
                reply_content: {
                    result: '',

                }
            })
            const element = document.getElementById('resultbox')
            setTimeout(() => {
                element.scrollTo({
                    x: 0,
                    top: element.scrollHeight,
                    behavior: 'smooth'
                })

                document.getElementById('qmess').value = ''
            }, 300)
            message = message.includes('温度横向对比查看') ? (this.menu === '大气' ? '空气' : '土壤') + message : message
            this.connectSever(message);
        },

        connectSever(message) {
            const that = this;
            const modeltype = this.issd ? 'deepseek-r1:70b' : 'qwen2-72b';
            that.eventSource = this.talkimgurl ? new EventSource(encodeURI(`${baseUrl}/queapi/robot_writing/gygpt_chat?query=${message}&robotId=106&modelName=${modeltype}&imageUrl=${this.talkimgurl}`, {})) : new EventSource(encodeURI(`${baseUrl}/queapi/robot_writing/gygpt_chat?query=${message}&robotId=106&modelName=${modeltype}`, {}))
            that.isconn = true;
            that.eventSource.addEventListener('open', (event) => {
                that.isconn = true;
                console.log('连接已建立', JSON.stringify(event))

            })
            let thinkend = 0;
            let returncontent = ''
            let endflag = false
            const lnum = this.talklist.length - 1
            that.eventSource.onmessage = (event) => {
                that.isstop = true;
                // console.log(event.data)
                const data = JSON.parse(event.data)

                // console.log(data)
                if (!data) {
                    that.talklist[that.talklist.length - 1].reply_content.result = '正在思考...'
                    that.talklist[that.talklist.length - 1].reply_content.thinktxt = ''
                    return
                }
                if (that.talklist[that.talklist.length - 1].reply_content.result == '正在思考...') {
                    that.talklist[that.talklist.length - 1].reply_content.result = ''
                }
                if (data.id) {
                    this.historyid = data.id
                    return;
                }

                that.isshowcw = true

                if (data.answer == '[DONE]') {
                    that.talklist[that.talklist.length - 1].reply_content.relatedquestion = data.relatedquestion;
                    return;
                }
                if (data.id) {
                    this.talkguanlianid = data.id
                    return;
                }

                // .replace('<think>', '<div style="color:#6c6c6c;background-color: #f2f2f2;padding:10px">').replace('</think>', '</div>')
                if (data.answer.includes('</think>')) {
                    thinkend = 2
                    return;
                }
                if (data.answer.includes('<think>')) {
                    thinkend = 1
                    return;
                }
                // if (!this.thinkend && this.issd) {
                //   this.thinkresult = this.thinkresult + data.answer;
                //   return
                // }

                // console.log(thinkend, that.talklist[that.talklist.length - 1].reply_content.thinktxt)
                that.talklist[that.talklist.length - 1].reply_content.imagereplys = data.imagereplys ? data.imagereplys : data.imagereply ? [data.imagereply] : null
                if (thinkend == 1 && this.issd) {
                    Vue.set(that.talklist[that.talklist.length - 1].reply_content, 'thinktxt', (that.talklist[that.talklist.length - 1].reply_content.thinktxt + data.answer).replace('undefined', ''))
                    // that.talklist[that.talklist.length - 1].reply_content.thinktxt = that.talklist[that.talklist.length - 1].reply_content.thinktxt + data.answer;
                } else {
                    that.talklist[that.talklist.length - 1].reply_content.result = that.talklist[that.talklist.length - 1].reply_content.result + data.answer;
                }
                // console.log(that.talklist[lnum].reply_content.thinktxt)
                this.$forceUpdate();
                if (that.talklist[lnum].reply_content.result.length % 10 == 0 || event.data.includes('，')) {
                    that.$nextTick(() => {
                        const element = document.getElementById('resultbox')
                        element.scrollTo({
                            x: 0,
                            top: Number.MAX_SAFE_INTEGER,
                            behavior: 'smooth'
                        })
                    })
                }
            }
            that.eventSource.onerror = (event) => {
                console.log(event)
                that.isconn = false;
                that.talkimgurl = ''
                that.eventSource.close()
                that.eventSource = null
                if (that.talklist[lnum].reply_content.imagereplys) {
                    that.talklist[lnum].reply_content.imagereplys.forEach(item => {
                        that.srcList.push(item.replace('http://47.96.179.72:11454/', 'http://strawberryai.web.shuzhiren.com/klgapi/'))
                    })
                    // that.srcList.push(...that.talklist[that.talklist.length - 1].reply_content.resultimgs)
                }
                that.$nextTick(() => {
                    const element = document.getElementById('resultbox')
                    element.scrollTo({
                        x: 0,
                        top: Number.MAX_SAFE_INTEGER,
                        behavior: 'smooth'
                    })
                })
            }
        },
        stopconn() {
            this.eventSource.close()
            this.eventSource = null
            this.isconn = false;
            window.localStorage.setItem('talklist', JSON.stringify(this.talklist))
            this.$emit('endtalk')
        },
        
    }
}




</script>

<style scoped lang="less">
.datamain {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url('../assets/img/bg.png');
    background-size: 100% 100%;

    .topbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F6F6F6;
        padding: 12px;

        .menuitem {
            font-size: 14px;
            color: #494949;

            span {
                padding: 8px 10px;
                border-radius: 8px;
                background-color: #15d200;
                color: #fff;
                font-size: 12px;
            }
        }

        .med {
            color: #000000d1;
            font-size: 18px;
            position: relative;
        }
        .med::after{
            background: linear-gradient( 352deg, #ffaac000 0%, #D94E6B 100%);
            border-radius: 6px;
            content: '';
            width: 35px;
            height: 10px;
            position: absolute;
            bottom: -4px;
            left: 0;
        }
    }

    .contentbox {
        width: calc(100% - 0px);
        height: calc(100% + 10px);
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .leftbox {
            width: 50px;
            background: #e2ebf5c2;
            border-radius: 10px;
            border: 1px solid #ffffff90;
            height: calc(100% - 60px);
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .menuitem {
                width: 100%;
                padding-top: 10px;
                color: #333C4C60;
                margin-bottom: 20px;

                .icon {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 20px;
                    }
                }

                .name {
                    margin-top: 5px;
                    width: 100%;
                    text-align: center;
                    font-size: 14px;

                }
            }

            .med {
                color: #3D57A4;
            }
        }

        .lefthide {
            width: 50px;
            background: #e2ebf5c2;
            border-radius: 10px;
            border: 1px solid #ffffff90;
            height: 165px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .menuitem {
                width: 100%;
                color: #333C4C60;

                .icon {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 20px;
                    }
                }

                .name {
                    width: 100%;
                    text-align: center;
                    font-size: 14px;

                }
            }

            .med {
                color: #3D57A4;
            }
        }
        .videobox{
            width: calc(100% - 70px);
            margin-left:15px;
            height:100%;
            overflow-y: auto;
            p{
                margin: 10px;
                font-size: 14px;
            }
            .myiframe{
                
            }
        }
        .rightbox {
            width: calc(100% - 60px);
            margin-left: 10px;
            height: 170px;
            border-radius: 10px;

            .databox {
                height: 164px;
                border-radius: 10px;
                border: 1px solid #ffffff90;
                padding: 5px 12px;
                position: relative;

                .refbox {
                    position: absolute;
                    right: 10px;
                    font-size: 18px;
                    color: #1d9bcf;
                    top: 6px;
                    cursor: pointer;
                    z-index: 9
                }

                .selectbox {
                    width: 120px;
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    z-index: 3;
                }

                /deep/ .el-carousel__container {
                    height: 100%;
                }

                /deep/ .el-carousel__indicators--horizontal {
                    display: none;
                }

                /deep/ .el-carousel__arrow--left {
                    left: 0px;
                }

                /deep/ .el-carousel__arrow--right {
                    right: 0px;
                }

                .uptime {
                    width: 100%;
                    font-size: 12px;
                    padding-top: 10px;
                    color: #00041F70;
                    text-align: right;
                }

                .titname {
                    text-align: left;
                    font-size: 16px;
                    color: #6D9E45;
                    margin: 10px 0;
                    margin-top: 0;
                }

                .valuebox {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    span {
                        font-size: 12px;
                        color: #95671f;
                    }

                    .valueitem {
                        width: calc(20% - 5px);
                        text-align: center;
                        background-color: #E8F1FF;
                        border-radius: 10px;
                        border: 1px solid #ffffff80;

                        .name,
                        .unit {
                            text-align: center;
                            font-size: 14px;
                            color: #333;
                            margin: 10px 0;
                        }

                        .value {
                            font-size: 16px;
                            color: #6D9E45;

                        }
                    }
                }

                .valuebox_t {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    color: #95671f;


                    .valueitem {
                        width: calc(25% - 5px);
                        margin: 5px 2px;
                        padding: 2px 5px;
                        text-align: center;
                        background-color: #E8F1FF;
                        border-radius: 10px;
                        border: 1px solid #ffffff80;

                        .name {
                            text-align: center;
                            font-size: 14px;
                            color: #333;
                            margin: 5px 0;
                        }

                        .value {
                            font-size: 14px;
                            color: #95671f;

                            span {
                                font-size: 10px;
                                color: 95671f;
                            }


                        }
                    }
                }
            }


        }

        .talkbox {
            width: calc(100% - 80px);
            height: calc(100% - 252px);
            border-radius: 10px;
            border: 1px solid #ffffff90;
            margin-top: 10px;
            background: linear-gradient(180deg, #B0D393 0%, rgba(178, 212, 153, 0.01) 100%);
            position: absolute;
            right: 10px;
            bottom: 70px;


            .talktitle {
                font-size: 16px;
                color: #00000060;
                width: 100%;
                padding: 12px;
                text-align: center;
                border-bottom: 1px dashed #00000060;
                position: relative;

                .allap {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    font-size: 20px;
                    color: #0066ff;
                }
            }

            .content {
                width: 100%;
                height: calc(100% - 45px);
                overflow-y: auto;

                .custom-markdown {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    overflow-y: auto;
                    line-height: 22px !important;
                    word-break: break-all;
                }

                .custom-markdown {
                    /deep/ .table {
                        border-collapse: collapse;
                        border-spacing: 0;
                    }

                    /deep/ .table {
                        border-top: 1px solid #333;
                        border-left: 1px solid #333;
                    }

                    /deep/ .table tbody tr td,
                    /deep/ .table thead tr th {
                        border-right: 1px solid #333;
                        border-bottom: 1px solid #333;
                        padding: 6px;
                    }
                }

                .xmindbox {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;

                    img {
                        width: 100%;
                    }
                }

                .zhuibox {
                    .zhuiitem {
                        display: flex;
                        align-items: center;
                        padding: 10px;
                        margin: 10px;
                        background-color: #1C223610;
                        font-size: 14px;
                        border-radius: 10px;
                        cursor: pointer;
                        color: #00000090;

                        img {
                            width: 20px;
                            margin-right: 12px;
                        }
                    }
                }

                .aiitem {
                    display: flex;
                    width: calc(100% + 0px);
                    position: relative;
                    margin: 5px 0;

                    .aileft {
                        padding: 10px 0;

                        img {
                            height: 40px;
                            margin-left: 10px;
                        }
                    }

                    .airight {
                        min-width: 180px;
                        max-width: calc(100% - 70px);
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-left: 10px;
                        text-align: left;
                        margin-bottom: 10px;
                        background: #ffffff70;

                        border-radius: 0px 12px 12px 12px;
                        position: relative;



                        .name {
                            font-size: 14px;
                            color: #333;
                            margin-bottom: 10px;

                            span {
                                font-size: 12px;
                                background: #F8F8F9;
                                border-radius: 6px;
                                padding: 4px 8px;
                                margin-left: 10px;
                            }
                        }

                        .aitext {
                            // width: 500px;
                            width: 100%;
                            color: #333;
                            padding: 10px;
                            font-size: 14px;

                            .loadinggif {
                                height: 52px;

                                img {
                                    height: 52px;
                                }
                            }

                            /deep/ .el-collapse-item__header,
                            /deep/ .el-collapse-item__wrap,
                            /deep/ .el-collapse-item__content {
                                background-color: #f2f2f2 !important;
                                font-size: 14px;
                                padding-bottom: 0;
                                line-height: 16px !important;

                            }

                            /deep/ .el-collapse-item__header {
                                color: #409eff
                            }

                            /deep/ .el-collapse-item__content {
                                color: #8b8b8b !important;
                                border-left: 1px solid #bdbdbd;
                                padding-left: 10px;
                            }

                            .resultbox {
                                color: #262626;
                                background-color: #ffffff70;
                                padding: 0 10px;
                                margin-bottom: 10px;
                                border-radius: 12px;
                            }

                            .custom-markdown code,
                            .custom-markdown /deep/ pre,
                            .custom-markdown pre code {
                                white-space: break-spaces;
                                word-break: break-all;
                                font-size: 14px;

                                /* 换行 */
                            }


                        }


                    }
                }

                .useritem {
                    position: relative;
                    color: #333;
                    width: calc(100% - 10px);
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row-reverse;

                    .userleft {
                        padding: 10px 0;

                        img {
                            width: 30px;
                        }
                    }

                    .userright {
                        // background: #FF009D;
                        padding-right: 3px;
                        text-align: left;
                        float: right;
                        margin: 10px 0;
                        max-width: 800px;
                        margin-left: 40px;

                        .usertext {
                            background: #ffffff70;
                            color: #333;
                            border-radius: 12px 0px 12px 12px;
                            font-size: 14px;
                            line-height: 15px;
                            padding: 10px 20px;
                            white-space: pre-wrap;
                        }
                    }
                }


            }
        }

        .sendbox {
            width: 100%;
            height: 40px;
            display: flex;

            .photo {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 20px;
                }
            }

            .inputbox {
                width: calc(100% - 110px);
                margin-left: 0px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                display: flex;

                .talkimg {
                    padding: 5px;
                    position: relative;

                    .delbox {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 15px;
                        height: 15px;
                        background-color: red;
                        color: #fff;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                    img {
                        width: 30px;
                    }
                }

                .delbtn {
                    position: absolute;
                    bottom: 4px;
                    right: 10px;
                    width: 30px;
                    height: 30px;
                    background: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 32px;
                    color: #fff;
                    border-radius: 50%;
                }

                input {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    padding-left: 10px;
                }

                input:focus {
                    outline: none;
                    /* 去除默认的outline，如果想完全去除边框，可以设置border为none */
                    border: none;
                    /* 直接移除边框 */
                }
            }

            .btnbox {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 30px;
                }
            }

            .skbtn {
                width: 50px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right:10px;
            }

            .skbtned {
                background-color: #3D57A4;
                color: #fff;
            }


        }

        .sendboxhide {
            width: calc(100% - 20px);
            height: 40px;
            display: flex
        ;
            position: absolute;
            right: 10px;
            bottom: 20px;

            .photo {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 20px;
                }
            }

            .inputbox {
                width: calc(100% - 150px);
                margin-left: 10px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                overflow: hidden;
                position: relative;

                .delbtn {
                    position: absolute;
                    bottom: 4px;
                    right: 10px;
                    width: 30px;
                    height: 30px;
                    background: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 32px;
                    color: #fff;
                    border-radius: 50%;
                }

                input {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    padding-left: 10px;
                }

                input:focus {
                    outline: none;
                    /* 去除默认的outline，如果想完全去除边框，可以设置border为none */
                    border: none;
                    /* 直接移除边框 */
                }
            }

            .btnbox {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 30px;
                }
            }

            .skbtn {
                width: 50px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 10px;
            }

            .skbtned {
                background-color: #3D57A4;
                color: #fff;
            }


        }

    }
}

/deep/ .custom-markdown p {
    line-height: 22px;

    img {
        max-width: 98%;
    }
}

/deep/ .custom-markdown {
    img {
        max-width: 98%;
    }
}
</style>
